//TAKE CARE ABOUT INTERVALS ORDER
// If the array passed as 'intervals' parameter is not ordered in descentant order,
// it will not crash, but it will not retrieve any colorStops. So try to take care
// about that aspect
//
// Your friendly neighborhood Angel Lopez Arias (Anx Developer for friends)

import type { ChartInterval, GradientColorStop } from '@/types/Chart'

function getColorStops(data: number[], chartIntervals: ChartInterval[]) {
  const colorStops: GradientColorStop[] = []
  let offsetValue = 0
  let stopOffset = 0
  chartIntervals = chartIntervals.sort((a, b) => b.order - a.order)
  const colors = chartIntervals.map((interval) => interval.color)
  const intervals = chartIntervals.map((interval) => interval.value)

  const minValue = Math.min.apply(null, data)
  const maxValue = Math.max.apply(null, data)

  const lowIndex = intervals.indexOf(minValue)
  const highIndex = intervals.indexOf(maxValue)

  //let newIntervals = intervals.slice(lowIndex, highIndex+1)
  const newColors = colors.slice(highIndex, lowIndex + 1)
  stopOffset = calculateStopOffset(newColors.length)

  for (let stop = 0; stop < newColors.length; stop++) {
    colorStops.push({
      offset: offsetValue,
      color: newColors[stop],
      opacity: 1
    } as GradientColorStop)
    offsetValue += stopOffset
  }
  return colorStops
}

function calculateStopOffset(elements: number) {
  if (elements <= 1) return 0
  else return 100 / (elements - 1)
}

/**
 * Get color steps (gradient) between two colors.
 * @author Arjan Haverkamp (arjan-at-avoid-dot-org)
 * @param {string} colorStart Any color. F.e.: 'red', '#f0f', '#ff00ff', 'rgb(x,y,x)', 'rgba(r,g,b,a)', 'hsl(180, 50%, 50%)'
 * @param {string} colorEnd Any color
 * @param {int} steps Number of color steps to return
 * @returns {array} Array of 'rgb(r,g,b)' or 'rgba(r,g,b,a)' arrays
 */
export const getColorSteps = (colorStart: string, colorEnd: string, steps: number): string[] => {
  const start = hex2rgba(colorStart),
    end = hex2rgba(colorEnd),
    opacityStep = (end[3] * 100 - start[3] * 100) / steps,
    colors: string[] = []

  let alpha = 0,
    opacity = start[3] * 100

  for (let i = 0; i < steps; i++) {
    alpha += 1.0 / steps
    opacity += opacityStep

    const c = [
      Math.round(end[0] * alpha + (1 - alpha) * start[0]),
      Math.round(end[1] * alpha + (1 - alpha) * start[1]),
      Math.round(end[2] * alpha + (1 - alpha) * start[2])
    ]

    colors.push(opacity == 100 ? `rgb(${c[0]},${c[1]},${c[2]})` : `rgba(${c[0]},${c[1]},${c[2]},${opacity / 100})`)
  }
  return colors.map((x) => rgb2Hex(x))
}

const hex2rgba = (hexColor: string, alpha = 1) => {
  const [r, g, b] = hexColor.match(/\w\w/g)?.map((x) => parseInt(x, 16)) ?? []
  return [r, g, b, alpha]
}

const rgb2Hex = (s: string) => s.match(/[0-9]+/g)?.reduce((a, b) => a + (Number(b) | 256).toString(16).slice(1), '#') ?? ''

export default {
  getColorStops,
  getColorSteps
}
